import url from './url';



export default url(({ id = ':id' }) => `/structures/${id}`);
